import styled from 'styled-components';

interface ImageCounterCenterBottomProps {
  currentPageNum: number;
  totalPageNum: number;
}

export const ImageCounterCenterBottom = ({ currentPageNum, totalPageNum }: ImageCounterCenterBottomProps) => {
  return (
    <ImageCounterChip>
      <ImageCounterText>{`${currentPageNum} / ${totalPageNum}`}</ImageCounterText>
    </ImageCounterChip>
  );
};

const ImageCounterChip = styled.div`
  width: 60px;

  padding: 6px;

  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;

  left: 50%;
  bottom: 12px;

  z-index: 50;

  transform: translateX(-50%);

  border-radius: 4px;
  background: rgba(80, 83, 99, 0.8);
`;

const ImageCounterText = styled.span`
  color: #fff;
  text-align: center;
  font-size: 10px;
  font-weight: 500;
  line-height: 85%; /* 8.5px */
`;
